import { UserBuilder } from '../../../../common/users/user-builder';
import { RandomGenerator } from '../../../../../test-utils';
var PhoneCallNoteBuilder = /** @class */ (function () {
    function PhoneCallNoteBuilder() {
        this.phoneCallNote = {
            id: RandomGenerator.randomId(),
            itemId: RandomGenerator.randomId(),
            createdByUser: new UserBuilder().build(),
            content: '<div>Yo</div>',
            locale: 'en',
            creationDate: Date.now(),
            lastUpdateDate: Date.now()
        };
    }
    PhoneCallNoteBuilder.prototype.withId = function (id) {
        this.phoneCallNote.id = id;
        return this;
    };
    PhoneCallNoteBuilder.prototype.withItemId = function (itemId) {
        this.phoneCallNote.itemId = itemId;
        return this;
    };
    PhoneCallNoteBuilder.prototype.withCreatedByUser = function (createdByUser) {
        this.phoneCallNote.createdByUser = createdByUser;
        return this;
    };
    PhoneCallNoteBuilder.prototype.withContent = function (content) {
        this.phoneCallNote.content = content;
        return this;
    };
    PhoneCallNoteBuilder.prototype.withLocale = function (locale) {
        this.phoneCallNote.locale = locale;
        return this;
    };
    PhoneCallNoteBuilder.prototype.withCreationDate = function (creationDate) {
        this.phoneCallNote.creationDate = creationDate;
        return this;
    };
    PhoneCallNoteBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.phoneCallNote.lastUpdateDate = lastUpdateDate;
        return this;
    };
    PhoneCallNoteBuilder.prototype.build = function () {
        return this.phoneCallNote;
    };
    return PhoneCallNoteBuilder;
}());
export { PhoneCallNoteBuilder };
//# sourceMappingURL=phone-call-note.builder.js.map